/* Generated by scripts/apply-brand.js from src/data/products.json — do not edit by hand */
import type { Product } from "./productTypes";
import img0 from "../assets/course-cards/sqe1.jpg";

export const BRAND_PRODUCTS: readonly Product[] = [
  {
    "title": "SQE Part 1",
    "id": "sqe1",
    "price": 299,
    "comingSoon": false,
    "description": "1,964 exam-style questions for the SQE Part 1, covering 13 topics, with detailed explanations, performance analytics and timed practice.",
    "length": "6 months",
    "css": "linear-gradient-3",
    "cardImage": "course-cards/sqe1.jpg",
    "subjectNames": [
      "SQE 1",
      "SQE Part 1"
    ],
    "trialable": true
  }
];

export const CARD_IMAGES: Record<string, string> = {
  "course-cards/sqe1.jpg": img0,
};
